import React from 'react';
import { useRouter } from 'next/navigation';
import { SearchType } from '@/types/job-title';
import NavigationTabs from '@/components/navigation/NavigationTabs';
import SearchBox from '../search-area/SearchBox';
import { SEARCH_MODE_TYPE } from '@/constants/common';
import { BASE_HEADER_HEIGHT } from '@/constants/profile-builder';
import { ACTIVE_TABS } from '@/constants/company-detail';
import { COMPANY_ROUTER_PATH } from '@/constants/router-path';

const Tabs = (props: {
  selectedTab: string;
  setSelectedTab: React.Dispatch<React.SetStateAction<string>>;
  searchType?: string;
}) => {
  const { selectedTab, setSelectedTab } = props;
  const observerRef = React.useRef<HTMLDivElement | null>(null);
  const router = useRouter();

  const handleSearch = (value: SearchType) => {
    if (!value) return;
    router.push(`${COMPANY_ROUTER_PATH}${value.id}/`);
  };

  return (
    <>
      <div ref={observerRef} />
      <div className="flex gap-x-10 sticky justify-between py-2 items-center z-[1101] bg-white top-0 mx-[calc(50%-50vw)] px-[calc(50vw-50%)] supports-[width:100dvw]:mx-[calc(50%-50dvw)] supports-[width:100dvw]:px-[calc(50dvw-50%)]">
        <NavigationTabs
          setSelectedTab={setSelectedTab}
          selectedTab={selectedTab}
          activeTabs={ACTIVE_TABS}
          sticky={false}
          initObserverRef={observerRef}
          topOffset={BASE_HEADER_HEIGHT}
          useRemainSpace={true}
        />
        <div className="w-[300px] shrink-0">
          <SearchBox
            enableAnimation={true}
            onChange={handleSearch}
            placeholder="搜索公司名称"
            noOptionsText="抱歉，暂未搜索到相关公司"
            mode={SEARCH_MODE_TYPE.COMPANY_SEARCH}
          />
        </div>
      </div>
    </>
  );
};

export default Tabs;
